import '../../../../Assets/app.base';
import './Index.scss';

// Components
import '../../../../Components/Carousel';
import '../../../../Components/EventList';
import '../../../../Components/Soundcloud';
import '../../../../Components/Mixcloud';
import '../../../../Components/VideoEmbed';

// Helper
import inlineForm from '../../../../Assets/scripts/forms/inlineForm';
import setLoaderAnim from '../../../../Assets/scripts/utils/loaderAnim';

async function toggleBookingForm() {
  const formTrigger = $('#booking-form-hidden')
  const formTarget = $('#booking-form-target')

  if (formTrigger.is(':visible')) {
    const { bookingRequestFormUrl } = window.artistDetailsControllerInit
    const request = await fetch(bookingRequestFormUrl,
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
    const formContent = await request.text()

    formTarget.append(formContent)
    inlineForm(formTarget, function bindMessageForm(element) {
      element.find('button[type="reset"]').click(toggleBookingForm)
    })
    formTrigger.hide()
    formTarget.show()
  } else {
    formTarget.hide()
    formTrigger.show()
    formTarget.empty()
  }
}

function init() {
  // Message form
  $('#booking-form-trigger').click(async function (e) {
    const element = $(this)
    e.preventDefault()

    const elementContent = element.text()
    setLoaderAnim(element)
    await toggleBookingForm()
    element.text(elementContent)
  })

}

$(function () {
  init()
})